module.exports = __webpack_public_path__ + "img/retencionfactura-icon.4846a537.png";